<template>
  <div v-if="kind === 'ornament'" class="flex items-center justify-center gap-3 py-2" aria-hidden="true">
    <span class="h-px w-16 bg-[#a0833c]/40"></span>
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#a0833c"><path d="M12 2l2.9 4.1L20 5l-1.1 5.1L23 12l-4.1 1.9L20 19l-5.1-1.1L12 22l-2.9-4.1L4 19l1.1-5.1L1 12l4.1-1.9L4 5l5.1 1.1z"/></svg>
    <span class="h-px w-16 bg-[#a0833c]/40"></span>
  </div>
  <hr v-else-if="kind === 'line'" class="my-3 border-[#1c4848]/15">
  <div v-else class="h-8" aria-hidden="true"></div>
</template>

<script setup>
defineProps({ kind: { type: String, default: 'ornament' } });
</script>
